import { FeatureMap, RawAccess } from './types';

// Infiere la unión de claves de los grupos, para tipar FEATURES con las claves que existen
// (SMP-637: FEATURES.GESTION_CONVOCATORIAS no existía y compilaba como undefined)
const definirFeatureGroups = <K extends string>(
    grupos: Array<{ id: number; name: string; features: Array<{ key: K; id: number }> }>
) => grupos;

export const featureGroups = definirFeatureGroups([
    {
        id: 1,
        name: 'USUARIOS',
        features: [
            { key: 'GESTION_USUARIOS', id: 1 },
            { key: 'ALTA_USUARIO', id: 2 },
            { key: 'EDICION_USUARIO', id: 3 },
            { key: 'CONSULTA_USUARIO', id: 4 },
            { key: 'ASIGNACION_ESTABLECIMENTO_USUARIO', id: 13 }
        ]
    },
    {
        id: 2,
        name: 'ADMINISTRACION',
        features: [
            { key: 'GESTION_ROLES', id: 5 },
            { key: 'ALTA_ROLES', id: 6 },
            { key: 'EDICION_ROLES', id: 7 },
            { key: 'CONSULTA_ROLES', id: 8 }
        ]
    },
    {
        id: 3,
        name: 'ESTABLECIMIENTOS',
        features: [
            { key: 'GESTION_ESTABLECIMIENTOS', id: 9 },
            { key: 'ALTA_ESTABLECIMIENTOS', id: 10 },
            { key: 'EDICION_ESTABLECIMIENTOS', id: 11 },
            { key: 'CONSULTA_ESTABLECIMIENTOS', id: 12 },
            { key: 'SOLICITUD_BAJA_ESTABLECIMIENTO', id: 32 },
            { key: 'APROBACION_SOLICITUD_ESTABLECIMIENTO', id: 33 },
            { key: 'DESCARGA_EXCEL_ESTABLECIMIENTO', id: 35 },
            // SMP-512: descarga masiva de PDF de visitas (id creado por el SQL del change). El 93 es
            // del RAR masivo y del 94 al 98 los reserva Erogaciones
            { key: 'DESCARGA_MASIVA_VISITAS', id: 99 }
        ]
    },
    {
        id: 4,
        name: 'PRESENTACIONES',
        features: [
            { key: 'GESTION_PRESENTACIONES', id: 14 },
            { key: 'ALTA_PRESENTACION', id: 15 },
            { key: 'EDICION_PRESENTACION', id: 16 },
            { key: 'CONSULTA_PRESENTACION', id: 17 },
            { key: 'ELIMINACION_PRESENTACION', id: 18 },
            { key: 'CAMBIAR_ESTADO_PRESENTACION', id: 34 },
            { key: 'VISUALIZACION_DE_DETALLE_PRESENTACION', id: 31 },
            { key: 'EDITAR_PRESENTACION_BO', id: 54 }
        ]
    },
    {
        id: 5,
        name: 'NOMINA',
        features: [
            { key: 'GESTION_NOMINA_EMPLEADOS', id: 19 },
            { key: 'GESTION_CERTIFICADO_DE_COBERTURA', id: 20 },
            { key: 'ASIGNACION_NOMINA_ESTABLECIMIENTO', id: 21 },
            { key: 'DESCARGA_NOMINA_EXCEL', id: 26 }
        ]
    },
    {
        id: 6,
        name: 'PUESTOS',
        features: [
            { key: 'GESTION_PUESTOS_DE_TRABAJO', id: 22 },
            { key: 'ALTA_PUESTO_DE_TRABAJO', id: 23 },
            { key: 'EDICION_PUESTO_DE_TRABAJO', id: 24 },
            { key: 'INACTIVACION_PUESTO_DE_TRABAJO', id: 25 }
        ]
    },
    {
        id: 7,
        name: 'ORGANISMOS',
        features: [
            { key: 'GESTION_ORGANISMOS', id: 27 },
            { key: 'ALTA_ORGANISMOS', id: 28 },
            { key: 'EDICION_ORGANISMOS', id: 29 },
            { key: 'INACTIVACION_ORGANISMOS', id: 30 }
        ]
    },
    {
        id: 8,
        name: 'VINCULACION_RGRL',
        features: [
            { key: 'GESTION_DE_PRESENTACIONES_VINCULACION_RGRL', id: 36 },
            { key: 'GENERACION_ARCHIVOS_SRT', id: 37 },
            { key: 'DESCARGA_PDF', id: 38 },
            { key: 'CARGA_RESPUESTA_SRT', id: 39 },
            { key: 'CONSULTA_DE_PRESENTACIONES_SRT', id: 42 }
        ]
    },
    {
        id: 9,
        name: 'CANCERIGENOS',
        features: [
            { key: 'GESTION_CANCERIGENOS', id: 43 },
            { key: 'ALTA_CANCERIGENOS', id: 44 },
            { key: 'EDICIÓN_CANCERIGENOS', id: 45 },
            { key: 'CONSULTA_CANCERIGENOS', id: 46 }
        ]
    },
    {
        id: 10,
        name: 'VISITAS',
        features: [
            { key: 'ALTA_DE_VISITAS', id: 50 },
            { key: 'GESTION_DE_VISITAS', id: 51 },
            { key: 'DESCARGA_DE_ACTA', id: 52 },
            { key: 'EDICION_ELIMINACION_RGRL_VEROSIMILITUD', id: 53 }
        ]
    },
    {
        id: 11,
        name: 'PERIODICOS',
        features: [
            { key: 'GESTION_DE_EMPLEADOS_EXPUESTOS', id: 55 },
            { key: 'GESTION_DE_CONVOCATORIAS', id: 56 }
        ]
    },
    {
        id: 12,
        name: 'VISITAS_RGRL',
        features: [{ key: 'GENERACION_ARCHIVOS_VISITAS', id: 57 }]
    },
    {
        id: 13,
        name: 'AVISO_DE_OBRA',
        features: [
            { key: 'GESTION_DE_AVISO_DE_OBRA', id: 59 },
            { key: 'ALTA_AVISO_DE_OBRA', id: 60 },
            { key: 'MODIFICACION_AVISO_DE_OBRA', id: 61 },
            { key: 'BAJA_AVISO_DE_OBRA', id: 62 },
            { key: 'EXTENSION_SUSPENSION_AVISO_DE_OBRA', id: 63 },
            { key: 'VISUALIZAR_AVISO_DE_OBRA', id: 64 }
        ]
    },
    {
        id: 14,
        name: 'CONTRATOS',
        features: [
            {
                key: 'CONTRATOS',
                id: 68
            }
        ]
    },
    {
        id: 15,
        name: 'PROVEEDORES',
        features: [
            {
                key: 'ALTA_PROVEEDOR',
                id: 71
            },
            {
                key: 'VISUALIZAR_Y_FILTRAR_PROVEEDORES',
                id: 72
            },
            {
                key: 'MODIFICAR_PROVEEDOR',
                id: 73
            },
            {
                key: 'ACTIVAR_O_DESACTIVAR_PROVEEDOR',
                id: 74
            },
            {
                key: 'VISUALIZAR_PROVEEDORES',
                id: 75
            }
        ]
    },
    {
        id: 16,
        name: 'ROAM',
        features: [
            { key: 'GESTION_SINIESTROS_ROAM', id: 84 },
            { key: 'CONSULTA_SINIESTRO_ROAM', id: 85 },
            { key: 'FINALIZACION_SINIESTRO_ROAM', id: 86 },
            { key: 'CANCELACION_SINIESTRO_ROAM', id: 87 },
            { key: 'GESTION_VISITA_DESDE_SINIESTRO_ROAM', id: 88 }
        ]
    },
    {
        id: 17,
        name: 'AUDITORIA_FACTURACION',
        features: [
            { key: 'VISUALIZAR_FACTURAS', id: 94 },
            { key: 'ALTA_FACTURA', id: 95 },
            { key: 'MODIFICAR_FACTURA', id: 96 },
            { key: 'ANULAR_FACTURA', id: 97 },
            { key: 'BUSCAR_PRESTADORES', id: 98 }
        ]
    }
]);

export type FeatureKey = (typeof featureGroups)[number]['features'][number]['key'];

export const getAccessUrl = (
    access: RawAccess | null,
    groupId: number,
    functionalityId: number
): string | null => {
    return access?.[groupId]?.[functionalityId]?.url ?? null;
};

export const hasAccess = (
    access: RawAccess | null,
    groupId: number,
    functionalityId: number
): boolean => {
    return !!access?.[groupId]?.[functionalityId];
};

export const getAccessValues = (access: RawAccess | null): FeatureMap<FeatureKey> => {
    const accessMap = {} as FeatureMap<FeatureKey>;

    featureGroups.forEach(({ id: groupId, features }) => {
        features.forEach(({ key, id: functionalityId }) => {
            const acc = access?.[groupId]?.[functionalityId];
            accessMap[key] = {
                url: acc?.url ?? null,
                hasAccess: !!acc
            };
        });
    });

    return accessMap;
};
